import { useQuery } from '@tanstack/react-query';
import { getChannelMarkers, getChannelMarkersQueryKey } from 'api/markerTypes';
import { map } from 'es-toolkit/compat';
import { StainType } from 'interfaces/stainType';
import { useMemo } from 'react';
import { useCurrentLabId } from 'utils/useCurrentLab';
import { useStainTypeIdToDisplayName } from 'utils/useStainTypeIdToDisplayName';

const useStudyChannelMarkerTypes = (
  studyId: string | undefined,
  {
    enabled = true,
  }: {
    enabled?: boolean;
  } = {}
) => {
  const { labId } = useCurrentLabId();
  const casesParams = { labId, filters: { studyId } };

  const { data: channelMarkersResponse, isLoading: isCheckingStudyChannels } = useQuery({
    queryKey: getChannelMarkersQueryKey(casesParams),
    queryFn: ({ signal }) => getChannelMarkers(casesParams, signal),
    enabled,
  });

  const { stainTypeIdToDisplayName, isLoadingStainTypeOptions } = useStainTypeIdToDisplayName(studyId);

  const namedMarkerTypes: StainType[] = useMemo(() => {
    return map(channelMarkersResponse?.channelMarkerTypes, (markerType, index) => ({
      id: markerType,
      displayName: stainTypeIdToDisplayName(markerType),
      canBeMifMarker: true,
      index,
    }));
  }, [channelMarkersResponse, stainTypeIdToDisplayName]);

  return { channelMarkersResponse, isCheckingStudyChannels, isLoadingStainTypeOptions, markerTypes: namedMarkerTypes };
};

export default useStudyChannelMarkerTypes;
